import React, { useEffect, useState, useRef, useContext } from 'react';
import AdminLayout from '../../components/admin-layout';
import ConsultationCard from '../../components/ConsultationCard/ConsultationCard';
import { CgSortAz } from 'react-icons/cg';
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter';
import { getAllConsultation } from '../../apis';
import Createrequest from '../../components/ConsultationCard/Createrequest';
import ConsultationViewRequest from '../../components/ConsultationCard/ConsultationViewRequest';
import { AppContext } from '../../appContext';
import LoaderCard from '../../components/ConsultationCard/LoaderCard';
import CSHeader from '../../PageComponentData/Consultations/CSHeader';
import CSMobileHeader from '../../PageComponentData/Consultations/CSMobileHeader';
import DashboardHeader from '../../PageComponent/Dashboard/DashboardHeader';
import CSTabs from '../../PageComponentData/Consultations/CSTabs';
import Placeholder from '../../components/placeholder';
import NoConsultation from '../../lottiefiles/no_consultation.json';
function Index() {
  const [tabType, setTabType] = useState('All');
  const [sortOpt, setSortOpt] = useState('pending');
  const [data, setData] = useState(null);
  const { loggedInUser } = useContext(AppContext);
  const hiddenButtonRef = useRef(null);
  const [reload, setReload] = useState(true);
  const [type, settype] = useState('');
  const [loader, setLoader] = useState(true);
  const [filterval, setfilterval] = useState('');
  function handelTabs(event, prop) {
    setTabType(prop);
    if (prop === 'Remote') {
      settype('consType');
      setfilterval('Virtual');
    } else if (prop === 'InPerson') {
      settype('consType');
      setfilterval('inperson');
    } else if (prop === 'General') {
      settype('priority');
      setfilterval('regular');
    } else if (prop === 'Urgent') {
      settype('priority');
      setfilterval('urgent');
    } else {
      settype('*');
      setfilterval('');
    }
    // const tabElm = document.querySelectorAll('.tabBtn');
    // const removeClass = ['bg-accent', 'text-white'];
    // const addClass = ['bg-accent', 'text-white'];
    // tabElm.forEach((data) => {
    //   data.classList.remove(...removeClass);
    // });
    // event.target.classList.add(...addClass);
  }

  const typesenseInitiate = () => {
    try {
      const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
        server: {
          apiKey: process.env.REACT_APP_TYPESENSE_API_KEY,
          nodes: [
            {
              host: process.env.REACT_APP_HOST_NAME_NEW,
              protocol: 'https',
            },
          ],
        },
        additionalSearchParameters: {
          collection: 'odds-hospitalConsultation',
          sort_by: 'createdAt:asc',
          query_by: '*',
        },
      });
      return typesenseInstantsearchAdapter.searchClient;
    } catch (e) {
      return 'failed';
    }
  };
  const searchClient = typesenseInitiate();

  const [createRequestBlock, setCreateRequestBlock] = useState(false);
  const [ViewRequestBlock, setViewRequestBlock] = useState(false);
  const [currentRequest, setCurrentRequest] = useState(null);

  function handelCreateRequestBlock() {
    setCreateRequestBlock(!createRequestBlock);
  }
  function handelViewRequestBlock(data) {
    setViewRequestBlock(!ViewRequestBlock);
    setCurrentRequest(data);
  }
  function onload() {
    // hiddenButtonRef.current.click();
    // location.reload();
    setReload(!reload);
  }
  const [reloadtext, setreloadtext] = useState('');
  const toGetAllConsultation = async (id, sortOpt, filterType, filterValue) => {
    try {
      setLoader(true);
      const res = await getAllConsultation(
        id,
        sortOpt,
        filterType,
        filterValue
      );
      console.log(res);
      if (res.status === 200) {
        setData(res?.data?.AllHospitalConsultation);
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    toGetAllConsultation(
      loggedInUser?.data?.hospitalProfile?._id,
      sortOpt,
      type,
      filterval
    );
  }, [loggedInUser, tabType, reload, sortOpt]);

  const notFound = (
    <div className="p-4 mt-4 bg-white shadow-md rounded-md flex justify-center items-center col-span-3 3xl:col-span-4">
     <Placeholder
        title='No Consultations found.'
        animationData={NoConsultation}
        height={200}
        message='No consultation requests were found at the moment.'
        />
    </div>
  );
  function centerTab(tabId) {
    const tabsContainer = document.getElementById('tabs-container');
    const tab = document.getElementById(tabId);
    if (tab && tabsContainer) {
      const containerWidth = tabsContainer.clientWidth;
      const tabWidth = tab.clientWidth;

      const offset = tab.offsetLeft - containerWidth / 2 + tabWidth / 2;

      tabsContainer.scrollTo({
        left: offset,
        behavior: 'smooth',
      });
    }
  }
  useEffect(() => {
          window.scrollTo(0, 0);
      }, []);
  return (
    <>
     <CSMobileHeader headerTxt='request history' />

      <AdminLayout headerTxt='request history'>
      
        <section className="pt-4 pb-20 md:lt-2 xl:p-3 xl:pb-0 h-[100vh] bg-transparent lg:h-[auto] md:h-[auto]">
          <section className="!pt-0 lg:!pt-4 md:!pt-4 lg:bg-white p-4 rounded-md mt-1 mb-14 xl:mb-0 xl:mt-3 xl:p-6 md:m-[16px] h-100vh md:h-[auto] lg:h-[auto] pb-[146px]">
          <CSTabs handelTabs={handelTabs} centerTab={centerTab} tabType={tabType} />
            <CSHeader
              tabType={tabType}
              sortOpt={sortOpt}
              setSortOpt={setSortOpt}
              handleCreateRequestBlock={handelCreateRequestBlock}
            />
            <div className="mt-6  grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 3xl:grid-cols-4 gap-4">
              {/* <ConsultationList/> */}
              {loader ? (
                <>
                  <LoaderCard />
                  <LoaderCard />
                  <LoaderCard />
                </>
              ) : data?.length != 0 ? (
                data?.map((item, key) => (
                  <ConsultationCard
                    data={item}
                    onload={onload}
                    fillBtnfun={() => handelViewRequestBlock(item)}
                  />
                ))
              ) : (
                notFound
              )}
            </div>
          </section>
        </section>
        <div
          className="fixed bottom-20 right-4 z-30 xl:hidden md:hidden"
          onClick={handelCreateRequestBlock}
        >
          <button className="text-white bg-accent baseText !font-medium flex items-center gap-1 px-4 py-2 rounded-md whitespace-nowrap">
            <span className="text-xl">+</span>
            New request
          </button>
        </div>
        {createRequestBlock && (
          <Createrequest
            closeFunction={handelCreateRequestBlock}
            editFormValue={null}
            profileData={loggedInUser?.data}
            onload={onload}
          />
        )}

        {ViewRequestBlock && (
          <ConsultationViewRequest
            currentdata={currentRequest?._id}
            reload={onload}
            // profileData={profileData}
            closeFunction={handelViewRequestBlock}
            navigatedFromNotification={false}
          />
        )} 

      </AdminLayout>
    </>
  );
}

export default Index;
